import React, { useState} from 'react'
import AppointmentService from '../../../../../services/api/appointment.service'
import PracticeLocationRoomForm from '../location-room-form/PracticeLocationRoomForm'
import APIResponse from '../../../../templates/components/APIResponse';
import DimLoader from '../../../../templates/components/DimLoader';

const PracticeLocationRoomAdd = (props) => {
    const [locationFormData, setLocationFormData] = useState(props.initialData || {})
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse, setApiResponse] = useState()

    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
      }
    
    const submitHandler = (data) => {
        setIsLoader(true)
        AppointmentService.addPracticeLocationRoom(data)
            .then(res => {
                setApiResponse(res);
            })
            .catch(error => {
                setApiResponse(error);
            })
            .finally(() => {
                setIsLoader(false)
            });
    }

    const clearForm = () => {
        setLocationFormData({})
    }
    return (
        <>
            {isLoader && <DimLoader />}
            <PracticeLocationRoomForm submitHandler={submitHandler} initialFormData={locationFormData} onClose={() => { props.onClose() }} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}

export default PracticeLocationRoomAdd